import { render, staticRenderFns } from "./ReviewCommentList.vue?vue&type=template&id=638077cb"
import script from "./ReviewCommentList.vue?vue&type=script&lang=js"
export * from "./ReviewCommentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports